<template>
  <div
      @click.stop
      class="popup-thank-you"
      v-body-scroll-lock="modalIsOpen"
      v-if="modalIsOpen"
  >
    <div class="popup_thank_inner">
      <div class="popup_thank_title">Вы успешно зарегистрировались для участия в розыгрыше поездки мечты!</div>
      <div class="popup_thank_subtitle">Розыгрыш призов состоится 9 августа 2021 года. Результаты будут опубликованы на сайте
        <a class="popup_thank_subtitle" href="https://www.lg.com/ru/lg-travel">www.lg.com/ru/lg-travel</a></div>
      <a class="popup_thank_btn" href="/">Перейти на главную страницу</a>
    </div>
  </div>
</template>

<script>
import {bus} from '../../../utils/bus'
export default {
  name: "ThankYou",
  data() {
    return {
      modalIsOpen: false,
    }
  },
  methods: {
    closeModal() {
      this.modalIsOpen = false;
      if(document.querySelector('.overlay-body').classList.contains('active-modal')) {
        document.querySelector('.overlay-body').classList.remove('active-modal')
      }
    },
    openModal() {
      this.modalIsOpen = true;
      document.querySelector('.overlay-body').classList.add('active-modal')
    }
  },
  mounted() {
    bus.$on('thank-close-modal', () => {
      this.closeModal()
    });
    bus.$on('thank-open-modal', () => {
      this.openModal()
    })
  }
}
</script>

<style lang="scss">
@import 'popup-thank-you';
</style>